import {
    DateTimeIcon,
    CheckmarkCircle03Icon,
    CancelCircleHalfDotIcon,
    ParagraphBulletsPoint02Icon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import moment from 'moment';
import { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { dashboard_info, get_closed_assignments, get_open_assignments } from '~/api/zero-api';
import DashboardHeader from '~/components/Dashboard/DashboardHeader';
import AssignmentsList from '~/components/Dashboard/AssignmentsList';
import SeparatedAssignmentsLists from '~/components/Shared/SeparatedAssignmentsLists';
import UserPopoverCard from '~/components/Shared/UserPopoverCard';
import CheckInAlert from '~/components/Spaces/CheckInAlert';
import {
    dateFormatterNoTime,
    mainContentContainerClass,
    pluralize,
    safe_get,
    safeProfilePic,
    scrollToTop
} from '~/other/Helper';
import {
    updateAssignmentsCount,
    updateClosedAssignments,
    updateLatestActivity,
    updateLoadingDashboard,
    updateOpenAssignments
} from '~/store/actions/DashboardActions';
import { update_current_user, update_user_analytics } from '~/store/actions/UserActions';
import LatestActivityList from '~/components/Dashboard/LatestActivityList';

class Dashboard extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            selectedAssignmentsType: "open",
            openAssignmentsPage: 1,
            totalOpenAssignments: 0,
            closedAssignmentsPage: 1,
            totalClosedAssignments: 0,
            latestActivityLoaded: false,
        };

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;

        if (this.props.location.search) {
            const params = new URLSearchParams(this.props.location.search);
            let redirect = params.get('redirect');
            if (redirect) {
                if (!redirect.startsWith('/')) {
                    redirect = '/' + redirect;
                }
                this.props.history.replace(this.props.location.pathname); // remove redirect 
                this.props.history.push(redirect);
                return;
            }
        }

        scrollToTop("page-head");
        this.getDashboardInfo()
    }

    getDashboardInfo = () => {
        var self = this;
        self.props.dispatch(updateLoadingDashboard(true));
        dashboard_info().then(function (success) {
            success.json().then(success => {
                let stats = safe_get(success, "user_stats.user_stats", {});
                self.props.dispatch(update_user_analytics(stats));
                self.props.dispatch(updateAssignmentsCount(stats.open_assignments));

                let newUser = safe_get(success, "user_stats.user", self.props.user);
                self.props.dispatch(update_current_user(newUser));

                let openAssignments = safe_get(success, "open_assignments.assignments", []);
                self.props.dispatch(updateOpenAssignments(openAssignments));

                let closedAssignments = safe_get(success, "closed_assignments.assignments", []);
                self.props.dispatch(updateClosedAssignments(closedAssignments));

                let latestActivity = safe_get(success, "recent_posts", []).splice(0, 5);
                self.props.dispatch(updateLatestActivity(latestActivity));

                if (self._isMounted) {
                    self.setState({
                        totalOpenAssignments: safe_get(success, "open_assignments.total_assignments", 0),
                        totalClosedAssignments: safe_get(success, "closed_assignments.total_assignments", 0),
                        latestActivityLoaded: true
                    });
                }

                self.props.dispatch(updateLoadingDashboard(false));
            });
        }, function (error) {
            console.log(error);
        });
    }

    toggleSelectedAssignmentsType = (e) => {
        this.setState({
            selectedAssignmentsType: this.state.selectedAssignmentsType === "open" ? "closed" : "open",
        });
    }

    goToAssignment = (assignment) => {

        let isOverDue = moment(assignment.due_date).isBefore(moment().format("YYYY-MM-DD"))
        let path = "/" + this.props.org_uuid + '/home/dashboard';

        if (assignment.type === "form") {
            if (assignment.completed) {
                path = '/' + this.props.org_uuid + '/home/team/' + assignment.team_uuids[0] + '/forms/submission_view/' + assignment.submission_uuid;
            } else if (!isOverDue) {
                if (assignment.submission_uuid) {
                    path = '/' + this.props.org_uuid + '/home/team/' + assignment.team_uuids[0] + '/forms/' + assignment.form_uuid + '/submission/' + assignment.submission_uuid;
                } else {
                    path = '/' + this.props.org_uuid + '/home/team/' + assignment.team_uuids[0] + '/forms/' + assignment.form_uuid + '/assignment/' + assignment.assignment_uuid + '/submit';
                }
            }
        } else if (assignment.type === "course") {
            if (assignment.completed) {
                path = '/' + this.props.org_uuid + '/home/team/' + assignment.team_uuids[0] + '/courses/submission_view/' + assignment.submission_uuid;
            } else if (!isOverDue) {
                if (assignment.submission_uuid) {
                    path = '/' + this.props.org_uuid + '/home/team/' + assignment.team_uuids[0] + '/courses/' + assignment.form_uuid + '/submission/' + assignment.submission_uuid;
                } else {
                    path = '/' + this.props.org_uuid + '/home/team/' + assignment.team_uuids[0] + '/courses/' + assignment.form_uuid + '/assignment/' + assignment.assignment_uuid + '/submit';
                }
            }


        } else if (assignment.type === "post" || assignment.post_uuid) {
            path = '/' + this.props.org_uuid + '/home/team/my_teams/feed/post/' + assignment.post_uuid;
        }

        this.props.history.push(path);
    }

    latestActivityFormatter = (post, index) => {
        let author = post.revised_by;
        return (
            <div key={index}>
                <div className="link-hover mar-btm-5 zero-blue" onClick={() => this.goToAssignment(post)}>
                    <strong>{post.title}</strong>
                </div>
                <p className="mar-btm-5 zero-dark-grey">
                    In {post.source_team.name}
                </p>

                <div>
                    <div className="media-left" style={{paddingRight: "7px"}}>
                        {safeProfilePic(author, "img-sm img-circle bulletin", "bulletin")}
                    </div>

                    <div className="media-body bulletin">
                        <UserPopoverCard user={author}>
                            <h3 className="author bulletin truncate name long link-hover zero-dark-grey"
                                style={{fontSize: '12px'}}>{author.first_name} {author.last_name}</h3>
                        </UserPopoverCard>
                        <br/>
                        <h3 className="author bulletin date">{dateFormatterNoTime(post.revised_at)}</h3>
                    </div>
                </div>

                <hr style={{margin: "10px 0px"}}/>
            </div>
        )
    }

    refreshDashboard = () => {
        this.setState({
            openAssignmentsPage: 1,
            closedAssignmentsPage: 1,
            totalOpenAssignments: 0,
            totalClosedAssignments: 0,
            latestActivityLoaded: false,
        }, () => {
            this.getDashboardInfo();
        });
    }

    loadMoreAssignments = () => {
        if (this.state.selectedAssignmentsType === "open") {
            this.loadMoreOpenAssignments();
        } else {
            this.loadMoreClosedAssignments();
        }
    }

    loadMoreOpenAssignments = () => {
        var self = this;
        this.setState({loadingOpenAssignments: true});
        let page = this.state.openAssignmentsPage + 1;
        get_open_assignments("?page=" + page).then(success => {
            success.json().then(success => {
                let assignments = safe_get(success, "assignments", []);
                let allOpenAssignments = self.props.open_assignments.concat(assignments);
                self.props.dispatch(updateOpenAssignments(allOpenAssignments));
                self.setState({openAssignmentsPage: page, loadingOpenAssignments: false});
            });
        });
    }

    loadMoreClosedAssignments = () => {
        var self = this;
        this.setState({loadingClosedAssignments: true});
        let page = this.state.closedAssignmentsPage + 1;
        get_closed_assignments("?page=" + page).then(success => {
            success.json().then(success => {
                let assignments = safe_get(success, "assignments", []);
                let allClosedAssignments = self.props.closed_assignments.concat(assignments);
                self.props.dispatch(updateClosedAssignments(allClosedAssignments));
                self.setState({closedAssignmentsPage: page, loadingClosedAssignments: false});
            });
        });
    }

    render() {
        const assignments = this.state.selectedAssignmentsType === "open" ? this.props.open_assignments : this.props.closed_assignments;
        const loadingAssignments = this.state.selectedAssignmentsType === "open" ? this.state.loadingOpenAssignments : this.state.loadingClosedAssignments;
        const hasMoreAssignments = this.state.selectedAssignmentsType === "open" ? this.state.totalOpenAssignments > (25 * this.state.openAssignmentsPage) : this.state.totalClosedAssignments > (25 * this.state.closedAssignmentsPage);

        const openAssignments = safe_get(this.props, "user_stats.open_assignments", 0);
        const completedAssignments = safe_get(this.props, "user_stats.completed_assignments", 0);
        const missedAssignments = safe_get(this.props, "user_stats.missed_form_assignments", 0);
        const totalAssignments = openAssignments + completedAssignments + missedAssignments;
        
        return (
            <div className={mainContentContainerClass()}>
                <DashboardHeader />

                <div id="page-content" className="no-padding-mobile" style={{paddingTop: 0}}>
                    {safe_get(this.props, "organization.feature_flags.desks", false) && this.props.user.show_check_in_dashboard_alert &&
                        <div className="row">
                            <div className="col-lg-12">
                                   {!this.state.latestActivityLoaded && 
                                    <div className="panel thin-border"
                                         style={{marginBottom: '1rem', padding: '15px 15px 15px 24px'}}>
                                        <div style={{display:'flex', gap:'1.5rem'}}>
                                                <Skeleton width={24} height={24} circle/>
                                                <Skeleton width={150} height={24}/>
                                        </div> 
                                        <div style={{marginTop:'1rem'}}>
                                            <div style={{marginLeft:'4rem'}}>
                                                <Skeleton width={200} height={14}/>         
                                            </div>
                                            <div  style={{marginLeft:'4rem'}}>
                                                <Skeleton width={150} height={14}/>         
                                            </div>
                                        </div>
                                    </div>
                                }
                                {this.state.latestActivityLoaded &&
                                    <div className="panel" style={{marginBottom: '1rem'}}>
                                        <CheckInAlert/>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    <div className="row hidden-xs">
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <div
                                className="panel panel-warning panel-colorful media middle pad-all mar-btm-10 zero-gold-background">
                                <div className="media-left">
                                    <div className="pad-hor">
                                        <HugeiconsIcon icon={DateTimeIcon} size={32} color="currentColor" strokeWidth={1.5} />
                                    </div>
                                </div>
                                <div className="media-body">
                                    <p className="text-2x mar-no text-semibold">{openAssignments}</p>
                                    <p className="mar-no">Open<br/>{pluralize(openAssignments, "Assignment")}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <div
                                className="panel panel-info panel-colorful media middle pad-all mar-btm-10 zero-plat-background">
                                <div className="media-left">
                                    <div className="pad-hor">
                                        <HugeiconsIcon icon={CheckmarkCircle03Icon} size={32} color="currentColor" strokeWidth={1.5} />
                                    </div>
                                </div>
                                <div className="media-body">
                                    <p className="text-2x mar-no text-semibold">{completedAssignments}</p>
                                    <p className="mar-no">Completed<br/>{pluralize(completedAssignments, "Assignment")}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <div
                                className="panel panel-info panel-colorful media middle pad-all mar-btm-10 zero-bronze-background">
                                <div className="media-left">
                                    <div className="pad-hor">
                                        <HugeiconsIcon icon={CancelCircleHalfDotIcon} size={32} color="currentColor" strokeWidth={1.5} />
                                    </div>
                                </div>
                                <div className="media-body">
                                    <p className="text-2x mar-no text-semibold">{missedAssignments}</p>
                                    <p className="mar-no">Missed<br/>{pluralize(missedAssignments, "Assignment")}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <div
                                className="panel panel-danger panel-colorful media middle pad-all mar-btm-10 zero-blue-background">
                                <div className="media-left">
                                    <div className="pad-hor">
                                        <HugeiconsIcon icon={ParagraphBulletsPoint02Icon} size={32} color="currentColor" strokeWidth={1.5} />
                                    </div>
                                </div>
                                <div className="media-body">
                                    <p className="text-2x mar-no text-semibold">{totalAssignments}</p>
                                    <p className="mar-no">Total<br/>{pluralize(totalAssignments, "Assignment")}</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row" style={{paddingLeft: "5px", paddingRight: "5px"}}>

                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-reduce-padding">
                            <AssignmentsList
                                assignmentsType={this.state.selectedAssignmentsType}
                                assignments={assignments}
                                onLoadMoreAssignments={this.loadMoreAssignments}
                                loadingMoreAssignments={loadingAssignments}
                                hasMoreAssignments={hasMoreAssignments}
                                onMutation={this.refreshDashboard}
                            />
                            <div className="flex justify-end pad-5">
                                <span className="blue-link" onClick={this.toggleSelectedAssignmentsType}>View {this.state.selectedAssignmentsType === "open" ? "past" : "open"} assignments...</span>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-reduce-padding">
                            <LatestActivityList posts={this.props.latest_activity} />
                        </div>

                    </div>

                </div>


            </div>

        );
    }
}

const mapStateToProps = store => {
    return {
        user: safe_get(store, "user.user", {}),
        user_stats: safe_get(store, "user.user_stats", {}),
        current_team: safe_get(store, "teams_helper.team", {}),
        organization: safe_get(store, "org_helper.organization", {}),
        org_uuid: safe_get(store, "org_helper.organization.organization_uuid", {}),
        open_assignments: safe_get(store, "dashboard.openAssignments", []),
        closed_assignments: safe_get(store, "dashboard.closedAssignments", []),
        latest_activity: safe_get(store, "dashboard.latestActivity", []),
        loading: safe_get(store, "dashboard.loading", false)
    }
}

export default withRouter(connect(mapStateToProps)(Dashboard));